import BackToTopButton from '@uikit/components/BackToTopButton/BackToTopButton';
import EnercityFooter from '@uikit/components/EnercityFooter/EnercityFooter';
import styles from './EnercityEasyGo.module.scss';
import { Benefits } from './components/Benefits/Benefits';
import { ContactSection } from './components/ContactSection/ContactSection';
import { Faq } from './components/Faq/Faq';
import { HomeAdvantage } from './components/HomeAdvantage/HomeAdvantage';
import { Stage } from './components/Stage/Stage';
import { Teasers } from './components/Teasers/Teasers';
import { VideoSection } from './components/VideoSection/VideoSection';

const EasyGoPage = () => {
  return (
    <>
      <main>
        <Stage />
        <VideoSection />
        <Benefits />
        <HomeAdvantage />
        <Teasers />
        <Faq />
        <ContactSection />
      </main>

      <div className={styles.footerContainer}>
        <BackToTopButton footerOffset={0} />
        <EnercityFooter skewOverlap={false} />
      </div>
    </>
  );
};

export default EasyGoPage;
